/* eslint-disable-next-line */

import { HOMEPAGE_LOCALE_URLS } from '@shared/config/lang.js'

const exclusionList = [
    /\/checkout\/.*\/payment/,
    /\/order-confirmation\/.*\/confirmation/,
    /\/oldmarketplace/,
    /\/marketplace/,
    /\/wall/,
    /\/oldlistings/,
    /\/listings/,
    /\/store\//,
    /\/cart/,
    /\/fair/,
    /\/page\//,
    /\/search/,
    /\/oldsearch/,
    /\/buy-now-pay-later\/enrollment\/.*/,
    /\/checkout\/address/,
    /\/checkout\/payment/,
    /\/order/,
    /\/retailers/,
    /\/brands/,
    /\/trademart/,

    // Moved over account pages
    /\/account\/*/,

    // Dropshipping pages
    /\/ds/,
    /\/ds\/*/,
]

const homeExclusionList = HOMEPAGE_LOCALE_URLS
/**
 *
 */
function init() {
    window.OCshouldSendToAnalytics = false
    const currentUrl = new URL(window.location.href)
    if (
        !exclusionList.some((el) => window.location.href.search(el) !== -1) &&
        !homeExclusionList.some((el) => currentUrl.pathname === el)
    ) {
        window.OCshouldSendToAnalytics = true
    }

    if (window.Store.accountId) {
        window.analytics.ready(function () {
            window.OCTrackClick = function (params) {
                let paramsObject = params
                if (typeof params === 'string') {
                    paramsObject = JSON.parse(params)
                }

                paramsObject['country'] = window.Store.country ?? ''
                if (window.Store.isExcludedFromTracking) {
                    return false
                }

                const { name, ...rest } = paramsObject

                window.analytics.track(name, {
                    ...rest,
                    ...window.OCSessionData,
                })
            }
            window.OCTrack = function (params) {
                window.OCTrackClick(params)
            }
        })
    }
}

if (globalThis.hasDelayedTracking) {
    window.addEventListener('client:initialized', () => {
        init()
    })
} else {
    init()
}
